var jQuery = $;
import slick from '../../node_modules/slick-carousel/slick/slick.min.js';

const app = {
    /**
     * Initialize.
     */
    init() {
        // Initialize sliders
        this.initSliders();

        this.CptProjectActive();

        // Show more function
        this.showMoreBlogs();
        this.showMoreCases();

        // Filter cases
        this.filterCases();

        // Toggle header subnavigation
        this.toggleSubnavigation();

        // Register our event listeners
        $(window).on('scroll', $.proxy(this.windowScrollHandler, this));
        $('.hamburger, .navigation-overlay').on('click', $.proxy(this.toggleHamburgerMenu, this));
        $('a[href="#"]').on('click', $.proxy(this.scrollToAnchor, this));
        $('.overlay, .closebrochurepopup, .closeoffertepopup').on('click', $.proxy(this.closeModal, this));
        $(".case-overview .image").click(e => $(".folding-menu").toggleClass("active"));
        $(".pageheader.menu .image").click(e => $(".folding-menu").toggleClass("active"));
        $('.button[href^="#"]').on('click', $.proxy(this.openModal, this));
        this.prefillPopup();
    },

    /**
     * Scroll to anchor.
     *
     * @param {event} e
     */
    scrollToAnchor(e) {
        // $('html, body').animate({scrollTop: $(e.currentTarget).offset().top - 50}, 800, () => window.location.hash = hash);
    },

    /**
     * Handles the scroll event.
     *
     * @param {event} e
     */
    windowScrollHandler(e) {
        $('header').toggleClass('scrolled', $(window).scrollTop() > 200);
    },

    /**
     * Open hamburger menu.
     *
     * @param {event} e
     */
    toggleHamburgerMenu(e) {
        // $(e.currentTarget).toggleClass('is-active');
        $(".hamburger").toggleClass('is-active');
        $("nav.navigation").toggleClass('visible');
        $(".navigation-overlay").toggleClass('is-active');
        $("body").toggleClass('is-locked');
    },

    /**
     * Open modal on event.
     *
     * @param {event} e
     */
    openModal(e) {
        $('[data-modal="' + $(e.currentTarget).attr('href') + '"]').addClass('active');
        $('body').addClass('scroll');
    },

    /**
     * Close modal on event.
     *
     * @param {event} e
     */
    closeModal(e) {
        $('.offertepopup, .brochurepopup').removeClass('active');
        $('body').removeClass('scroll');
    },

    /**
     * Prefill popup based on body class.
     *
     */
    prefillPopup() {
        var id = parseInt($('body').attr('class').split(' ')[2].replace('page-id-', ''));
        var options = {
            427: 'Personeelsfeest',
            429: 'Bedrijfsfeest',
            431: 'Walking en seated diners',
            433: 'Seminaries & Presentaties',
            435: 'Productlancering',
            437: 'Modeshows',
            439: 'Event op maat'
        };
        $('#input_5_8').val(options[id]);
    },

    /**
     * Init sliders.
     *
     */
    initSliders() {

        // Pagehero Slider
        if ($('.pagehero-slider').length) {
            $('.pagehero-slider').slick({
                autoplay: true, autoplaySpeed: 5000, slidesToShow: 1, dots: false, arrows: true,
                fade: true, prevArrow: $('.pagehero .arrows .prev'), nextArrow: $('.pagehero .arrows .next')
            });
        }

        // Pagehero Detail Slider
        if ($('.pagehero-detail-slider').length) {
            $('.pagehero-detail-slider').slick({
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                dots: false,
                arrows: true,
                fade: true,
                prevArrow: $('.pagehero-detail .arrows .prev'),
                nextArrow: $('.pagehero-detail .arrows .next')
            });
        }

        // Slider-Content Slider
        if ($('.slider-content .slider-holder .slider').length) {
            $('.slider-content .slider-holder .slider').slick({
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                dots: false,
                arrows: true,
                fade: true,
                prevArrow: $('.slider-content .slider-holder .arrows .prev'),
                nextArrow: $('.slider-content .slider-holder .arrows .next')
            });
        }
    },

    /**
     * Show more function
     *
     */
    showMoreBlogs() {
        $(".loadmoreblogs").on('click', function (e) {
            e.preventDefault();
            $(this).parent().parent().parent().find($('.col:hidden')).slice(0, 3).slideDown().css('display', 'flex');
        });
    },
    showMoreCases() {
        $(".loadmorecases").on('click', function (e) {
            e.preventDefault();
            $(this).parent().parent().parent().find($('.col:hidden')).slice(0, 2).slideDown().css('display', 'flex');
        });
    },


    /** Add active menu item when page is CPT projecten */

    CptProjectActive() {
        var loc = window.location.href; // returns the full URL
        if(/project/.test(loc)) {
            $('ul.navigation-list a[href*="/projecten/"]').addClass('active');
        }
    },

    /** Filter Projects */
    filterCases() {

        'use strict';

        var $filters = $('.filter[data-filter]'),
            $project = $('.project[data-category]');

        $filters.on('click', function(e) {
            e.preventDefault();
            var $this = $(this);

            $filters.removeClass('is-active');
            $this.addClass('is-active');

            var $filterCategory = $this.attr('data-filter');

            if ($filterCategory == 'all') {
                $project.removeClass('is-animated')
                    .fadeOut().finish().promise().done(function() {
                    $project.each(function() {
                        $(this).addClass('is-animated').fadeIn();
                    });
                });
            } else {
                $project.removeClass('is-animated')
                    .fadeOut().finish().promise().done(function() {
                    $project.filter('[data-category = "' + $filterCategory + '"]').each(function() {
                        $(this).addClass('is-animated').fadeIn();
                    });
                });
            }
        });
    },

    /** Toggle Subnavigation */
    toggleSubnavigation() {
        $("nav.navigation ul li.has-children .toggle-dropdown").click(function(e) {
            e.preventDefault();
            $(this).parent().toggleClass("is-opened").find("ul").slideToggle("slow");
        });
    },

};

$(document).ready($.proxy(app.init, app));
